// extracted by mini-css-extract-plugin
export default {"root":"ax03OXWNxFO1uAKJKKCc","open":"qjFboEVdYtu1mDbYkYWf","cross":"sSYB8amncAFZcGqHP4o0","placeHolderShimmer":"U2_UVf5B4PSLa7CE7v9A"};